
import {defineComponent} from "vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";

export default defineComponent({
  name: "Worldline",
  components: {
    BaseTitle,
    BaseContainer,
  }
});
